/**
 * NOVEN — premium micro-interactions.
 * - Scroll reveal for section headings, cards, and value-prop blocks.
 * - Soft image fade-in once photography has actually loaded.
 * - Fully respects prefers-reduced-motion and degrades to "everything
 *   visible" if this script fails to load (see noven-black-gold.css §11).
 */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var REVEAL_SELECTORS = [
    ".title-wrapper",
    ".title-wrapper-with-link",
    ".product-card",
    ".collection-card",
    "[class*='__group_header']",
    "[id^='section_why_choose_us'] [class*='group']"
  ];

  function markReveal() {
    var nodes = document.querySelectorAll(REVEAL_SELECTORS.join(","));
    nodes.forEach(function (el) {
      el.classList.add("noven-reveal");
    });
    return nodes;
  }

  function setupScrollReveal() {
    document.documentElement.classList.add("js-anim");
    var nodes = markReveal();

    if (reduceMotion || !("IntersectionObserver" in window)) {
      nodes.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.05 }
    );

    nodes.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var alreadyVisible = rect.top < window.innerHeight && rect.bottom > 0;
      if (alreadyVisible) {
        el.classList.add("is-visible");
      } else {
        observer.observe(el);
      }
    });
  }

  function setupImageReveal() {
    if (reduceMotion) return;
    var images = document.querySelectorAll(
      ".product-card__content img, .product-grid__card img"
    );
    images.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) return;
      img.classList.add("noven-img-loading");
      img.addEventListener(
        "load",
        function () {
          img.classList.remove("noven-img-loading");
          img.classList.add("noven-img-loaded");
        },
        { once: true }
      );
    });
  }

  function init() {
    setupScrollReveal();
    setupImageReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-scan after Shopify section re-renders (theme editor, quick-add re-renders, etc.)
  document.addEventListener("shopify:section:load", init);
})();
